import { useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import Header from './pages/HeaderFolder/Header';
import Footer from './pages/FooterFolder/Footer';
import ScrollToTop from './components/scroll-to-top';
import { useAnalytics } from './src/useAnalytics';

interface Props {
  children: React.ReactNode;
}

function App(props: Props) {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    const existing = document.getElementById('enzuzo-cookiebar-script');

    if (existing) return;

    const script = document.createElement('script');
    script.id = 'enzuzo-cookiebar-script';
    script.src =
      'https://app.enzuzo.com/scripts/cookiebar/7bc30294-5dd4-11f1-9d27-6faac70a8d03';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-white">
      <ScrollToTop />
      <div className="relative min-h-screen bg-cover bg-white">
        <Header />
        <main>
          {props.children}
          {(location.pathname === '/' ||
            location.pathname.includes('/hrl-'))}
          {/* Uncomment this to enable subscribe form again and comment line above */}
          {/* location.pathname.includes('/hrl-')) && <SubscribeForm />} */}
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default App;